import React, { useMemo, useState } from 'react';
import Classes from './RecordTable.module.css';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';
import EmailInvoicePopup from './EmailInvoicePopup/EmailInvoicePopup';
import { AnimatePresence } from 'framer-motion';

function money(n, c = 'USD') {
  const v = Number(n || 0);
  try {
    return v.toLocaleString(undefined, { style: 'currency', currency: (c || 'USD').toUpperCase() });
  } catch {
    return `$${v.toFixed(2)}`;
  }
}

// Small inline pill for "Refunded $X"
function RefundedPill({ amount, currency }) {
  if (!amount || amount <= 0) return null;
  return (
    <span
      // style={{
      //   marginLeft: 8,
      //   padding: '2px 8px',
      //   borderRadius: 999,
      //   background: 'rgba(99,102,241,0.12)',
      //   border: '1px solid rgba(99,102,241,0.35)',
      //   color: '#6366F1',
      //   fontSize: 12,
      //   fontWeight: 600,
      //   whiteSpace: 'nowrap',
      // }}
      // title="Refund applied"
    >
      {/* {`Refunded ${money(amount, currency)}`} */}
    </span>
  );
}

export default function TableRow({ value }) {
  const canPay = String(value?.Status || '').toLowerCase() !== 'completed';
  const [openEmailInvoicePopup, setopenEmailInvoicePopup] = useState(false);
  const refunded = Number(value?.refundedTotal || 0);
  const currency = value?.currency || 'USD';

  const handleCloseEmailPopup = () => setopenEmailInvoicePopup(false);
  const handleOpenEmailPopup = () => setopenEmailInvoicePopup(true);

  // Build a compact mobile label (e.g., "Total (after refunds)")
  const totalLabel = useMemo(
    () => (refunded > 0 ? 'Total (after refunds)' : 'Total'),
    [refunded]
  );

  return (
    <>
      <div className={Classes.customerRow} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}>
          <h5>{value.Invoice}</h5>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem2}`}>
          <h5>{value.Date}</h5>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <h5>{value.DateDue}</h5>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem4}`}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'flex-start' }}>
            <h5>{value.Total}</h5>
            <RefundedPill amount={refunded} currency={currency} />
          </div>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          <DropDown selectedValue={value.Status} isDropDown={false} />
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem6}`}>
          <MoreDropDown
            invoiceId={value._id}
            canPay={canPay}
            handleOpenEmailPopup={handleOpenEmailPopup}
            // customers can open email/share/payment as before
          />
        </div>
      </div>

      {/* Mobile */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Invoice</h4><h5>{value.Invoice}</h5></div>
          <div className={Classes.mobElem}><h4>Date</h4><h5>{value.Date}</h5></div>
          <div className={Classes.mobElem}><h4>Due Date</h4><h5>{value.DateDue}</h5></div>
        </div>
        <div>
          <div className={Classes.mobElem}><h4>Status</h4><DropDown selectedValue={value.Status} isDropDown={false} /></div>
          <div className={Classes.mobElem}>
            <h4>{totalLabel}</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <h5>{value.Total}</h5>
              <RefundedPill amount={refunded} currency={currency} />
            </div>
          </div>
        </div>
        <MoreDropDown
          invoiceId={value._id}
          canPay={canPay}
          handleOpenEmailPopup={handleOpenEmailPopup}
        />
      </div>
            <AnimatePresence>
        {openEmailInvoicePopup && <EmailInvoicePopup handleClose={handleCloseEmailPopup} invoiceId={value._id}/>}
      </AnimatePresence>
    </>
  );
}
